import { render, staticRenderFns } from "./ViewFeedbackNotificationModal.vue?vue&type=template&id=be8f6dd8&"
import script from "./ViewFeedbackNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ViewFeedbackNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports